import { render, staticRenderFns } from "./BmPedidoProductoDetalles.vue?vue&type=template&id=c0314df4&"
import script from "./BmPedidoProductoDetalles.vue?vue&type=script&lang=js&"
export * from "./BmPedidoProductoDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports